import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingDock from "@/components/FloatingDock";
import QuoteModal from "@/components/QuoteModal";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

export default function Layout() {
  const loc = useLocation();
  useSmoothScroll();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <div className="min-h-screen bg-[#060B11]">
      <Header />
      <main className="pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      <FloatingDock />
      <QuoteModal />
    </div>
  );
}
